import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const CloseIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-close${className ? ` ${className}` : ""}`}
    size={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label={ariaLabel}
  >
    <path
      d="M12 4L4 12"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 4L12 12"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default CloseIcon;
